export default __webpack_public_path__ + "static/media/car-battery.76aa5ea8.png";